import TranslateDrawer from "./TranslateDrawer";

export default TranslateDrawer;
